import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map, Observable } from 'rxjs';

import { Sha256Service } from '../../analytics/sha-256.service';
import { BrandingService } from '../../application-settings/service/branding.service';
import { GiftCardService } from '../../gift-cards/service/gift-card.service';
import { Language } from '../../language/model/language';
import { LanguageService } from '../../language/service/language.service';
import { ApplicationSettingsService } from '../../application-settings/service/application-settings.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent implements OnInit {
  readonly faGift = faGift;
  language: Language = 'en';
  flagCountryCode: string = 'gb';
  logoDataUrl$: Observable<string>;
  useremail$ = this.sha256Service.email$;
  userphone$ = this.sha256Service.phone$;
  onlineGiftCardActive$: Observable<boolean>;

  constructor(
    protected readonly modalService: NgbModal,
    private readonly languageService: LanguageService,
    private readonly brandingService: BrandingService,
    private readonly sha256Service: Sha256Service,
    protected readonly giftCardService: GiftCardService,
    private readonly applicationSettingsService: ApplicationSettingsService,
  ) {
    this.logoDataUrl$ = this.brandingService.clientPortalLogoDataUrl();
    this.onlineGiftCardActive$ =
      this.applicationSettingsService.applicationSettings$.pipe(
        map((applicationSettings) => applicationSettings.onlineGiftCardActive),
      );
  }

  ngOnInit(): void {
    this.language = this.languageService.getLanguage();
    this.flagCountryCode = this.getCountryCodeFromLocale();
  }

  private getCountryCodeFromLocale() {
    const US_FLAG_COUNTRY_CODE: string = 'us';
    const GB_FLAG_COUNTRY_CODE: string = 'gb';

    return this.languageService
      .getLocale()
      .toLowerCase()
      .substring(3, 5)
      .replace(US_FLAG_COUNTRY_CODE, GB_FLAG_COUNTRY_CODE);
  }
}
